import { getToken } from '@/CommonDP/utils';
import request from "@/CommonDP/utils/request";

export default {
  downloadFile(filePath) {
    return request({
      responseType: "blob",
      url: `/download/${filePath}?token=${getToken()}`,
      method: "get"
    });
  }
};
